var _defs, _g, _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirforce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2.8 2.2 58.4 58.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fu",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b3d52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6d7088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121320"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#16171f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 27 L27 22 L37 22 L61 27 L61 32 L37 33 L27 33 L3 32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 5,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 17,
    width: 5,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 17,
    width: 5,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 18,
    width: 5,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 52 L32 48 L44 52 L44 56 L20 56Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 3 Q36.5 5 36.5 14 L35 53 L33.5 60 L30.5 60 L29 53 L27.5 14 Q27.5 5 32 3Z",
    fill: "url(#fu)",
    stroke: "#0c0c14",
    strokeWidth: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 11,
    rx: 1.6,
    ry: 3.2,
    fill: "#a9aec8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirforce);
export default __webpack_public_path__ + "static/media/airforce.2fba04234667ad09a2e3023029f30946.svg";
export { ForwardRef as ReactComponent };